import React from 'react'
import {broadcast, listen, stop_listen, post_gql, marker_layer, INIT_POINT_SETTINGS} from '../../utils'
import { PRIKAZ10_HASH, PRIKAZ10_MAPPING } from '../../prikaz10'
import './index.css'

class PointTool extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mode: 'cursor',
      mouse_down_coords: false,
      container_mouse_coords: false,
      edit_layer_id: false,
      top: 10,
      left: 30,
      point_settings: INIT_POINT_SETTINGS,
      agriculture_filter: "",
      user_id: false,
      hidden: false,
      common_hidden: false,
      icons_hidden: false,
      listners: []
    }
  }

  componentDidMount(){
    const listners = [
      {type: "containter_onMouseMove", fnc: ({detail}) => {
        this.setState({container_mouse_coords: [detail.clientX, detail.clientY]})
        if (!!this.state.mouse_down_coords)
          this.setState({
            top: this.state.top + (detail.clientY - this.state.mouse_down_coords[1]),
            left: this.state.left + (detail.clientX - this.state.mouse_down_coords[0]),
            mouse_down_coords: [detail.clientX, detail.clientY]
          })
      }},
      {type: "toolbar_mode_change", fnc: ({detail}) => this.setState({mode: detail.mode, edit_layer_id: false})},
      {type: "set_point_settings", fnc: ({detail}) => this.setState({point_settings: detail})},
      {type: "toolbar_delete", fnc: ({detail}) => {
        if (this.state.edit_layer_id) {
          post_gql(
            `mutation {geomapLayerDelete(layer_id: ${this.state.edit_layer_id})}`,
            resp => {
              broadcast("remove_layer", this.state.edit_layer_id)
              broadcast("toolbar_mode_change", {mode: 'cursor'})
              broadcast("layer_edit", {id: false, type: "marker"})
            }
          )
        }
      }},
      {type: "map_click", fnc: ({detail}) => {
        const obj = detail.event.object

        if (detail.mode === "cursor" && obj && !obj.bbox && !!obj.properties.point_settings) {
          this.setState({edit_layer_id: obj.properties.id, point_settings: obj.properties.point_settings})
          broadcast("layer_edit", {id: obj.properties.id, type: "point"})
          broadcast("point_settings", {user_id: this.props.user_id, point_settings: obj.properties.point_settings})
        } else {
          if (detail.mode === "marker") {
            post_gql(
              `mutation { geomapLayerCreate(
                geomap_id: "${window.location.pathname.replace("/t/", "")}",
                user_id: "${this.props.user_id}",
                type: POINT,
                point_coords: ${JSON.stringify(detail.event.coordinate)},
                point_settings: {
                  icon_atlas: "${this.state.point_settings.icon_atlas}",
                  icon_mapping: "${this.state.point_settings.icon_mapping}",
                  icon: "${this.state.point_settings.icon}",
                  size: ${this.state.point_settings.size},
                  angle: ${this.state.point_settings.angle},
                  min_pixels: ${this.state.point_settings.min_pixels},
                  max_pixels: ${this.state.point_settings.max_pixels},
                  tooltip_text: ${JSON.stringify(this.state.point_settings.tooltip_text)},
                }){id user_id point_coords type point_settings {
                  icon_atlas icon_mapping icon size angle min_pixels max_pixels tooltip_text
              }}}`,
              resp => {
                const props = resp.data.data.geomapLayerCreate
                broadcast("add_or_replace_layer", marker_layer(props.point_coords, props))
              }
            )
          }
        }
      }},

      {type: "point_icon", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, icon: detail.value}})},
      {type: "point_size", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, size: detail.value}})},
      {type: "point_angle", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, angle: detail.value}})},
      {type: "point_min_pixels", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, min_pixels: detail.value}})},
      {type: "point_max_pixels", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, max_pixels: detail.value}})},
      {type: "update_point_tooltip_text", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, tooltip_text: detail.value}})},

      {type: "update_point_icon", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, icon: detail.value}})},
      {type: "update_point_size", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, size: detail.value}})},
      {type: "update_point_angle", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, angle: detail.value}})},
      {type: "update_point_min_pixels", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, min_pixels: detail.value}})},
      {type: "update_point_max_pixels", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, max_pixels: detail.value}})},
      {type: "point_tooltip_text", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, tooltip_text: detail.value}})},
    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){this.state.listners.forEach(l => stop_listen(l.type, l.fnc))}

  render() {
    if (this.state.mode === 'marker' || !!this.state.edit_layer_id){
      return(
        <div className="polygon-tool" style={{top: this.state.top, left: this.state.left}}>
          <div
            className="tool-header"
            onMouseDown={e => this.setState({mouse_down_coords: this.state.container_mouse_coords})}
            onMouseUp={e => this.setState({mouse_down_coords: false})}
          >
            <span className="tool-header-title">&nbsp;{this.state.edit_layer_id ? "редактирование" : "настройки"} маркера</span>
            <div className="tool-header-btns">
              <span
                className="tool-header-btn"
                onClick={() => this.setState({hidden: !this.state.hidden})}
              >{this.state.hidden ? "▾" : "▸"}</span>
              <span
                className="tool-header-btn"
                style={{transform: `rotateZ(45deg)`}}
                onClick={() => {
                  broadcast("toolbar_mode_change", {mode: 'cursor'})
                  broadcast("layer_edit", {id: false, type: "marker"})
                }}
              >+</span>
            </div>
          </div>
          {
            this.state.hidden ? null :
            <div className="tool-body">
              <div className="tool-body-header" onClick={() => this.setState({common_hidden: !this.state.common_hidden})}>
                <span className="tool-header-title">&nbsp;&nbsp;основные</span>
                <span className="tool-header-btn">{this.state.common_hidden ? "▾" : "▸"}&nbsp;</span>
              </div> {
                this.state.common_hidden ? null : <div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">размер (метры)</span>
                      <input
                        className="tool-input"
                        value={this.state.point_settings.size}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_point_size" : "point_size", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">мин размер (пикс)</span>
                      <input
                        className="tool-input"
                        value={this.state.point_settings.min_pixels}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_point_min_pixels" : "point_min_pixels", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">макс размер (пикс)</span>
                      <input
                        className="tool-input"
                        value={this.state.point_settings.max_pixels}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_point_max_pixels" : "point_max_pixels", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>
                    <div className="tool-input-cont">
                      <span className="tool-input-label">угол</span>
                      <input
                        className="tool-input"
                        value={this.state.point_settings.angle}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_point_angle" : "point_angle", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                      />
                    </div>

                    <div className="tool-input-cont">
                      <textarea
                        className="tool-input-area"
                        value={this.state.point_settings.tooltip_text}
                        onChange={e => broadcast(!!this.state.edit_layer_id ? "update_point_tooltip_text" : "point_tooltip_text", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                      />
                    </div>
                  </div>
              }

              <div className="tool-body-header" onClick={() => this.setState({icons_hidden: !this.state.icons_hidden})}>
                <span className="tool-header-title">&nbsp;&nbsp;маркер</span>
                <span className="tool-header-btn">{this.state.icons_hidden ? "▾" : "▸"}&nbsp;</span>
              </div>
              {
                  this.state.icons_hidden ? null : <div style={{padding: "6px", borderBottom: '1px solid gray'}}>
                    поиск
                    <input
                      className="tool-input"
                      style={{width: "calc(100% - 12px)"}}
                      value={this.state.agriculture_filter}
                      onChange={e => this.setState({agriculture_filter: e.currentTarget.value})}
                    />
                </div>
              }
              {
                this.state.icons_hidden ? null : <div style={{maxHeight: '400px', overflowY: 'auto'}}>
                {
                  Object.keys(PRIKAZ10_HASH)
                    .filter(key => {
                      return(
                        PRIKAZ10_HASH[key].desc.toLowerCase().includes(this.state.agriculture_filter.toLowerCase())
                      )

                    })
                    .map(key => {

                    var arr = []
                    const subkeys = [
                      "сущ_мз", "сущ_рз", "сущ_фз", "план_мз", "план_рз", "план_фз", "рек_мз", "рек_рз", "рек_фз", "ликв_мз", "ликв_рз", "ликв_фз"
                    ]

                    subkeys
                    .filter(subk => !!PRIKAZ10_MAPPING[`${key}_${subk}`])
                    .forEach(subk => {
                      const mapping_key = `${key}_${subk}`
                      var transform = 0
                      var status = ""
                      var value = ""

                      switch (subk.split("_")[0]) {
                        case "сущ":
                          status = "Cущ. и строящийся"
                          break;
                        case "план":
                          status = "План. к размещению"
                          break;
                        case "ликв":
                          status = "План. к ликвидации"
                          break;
                        default:
                          status = "План. к реконструкции"
                      }


                      switch (subk.split("_")[1][0]) {
                        case "м":
                          transform = 33
                          value = "Мест. значения"
                          break;
                        case "ф":
                          transform = 77
                          value = "Фед. значения"
                          break;
                        default:
                          transform = 50
                          value = "Рег. значения"
                      }

                      arr.push(<div
                          key={mapping_key}
                          className={`${this.state.point_settings.icon === mapping_key ? 'active' : ''}`}
                          style={{
                            cursor: "pointer",
                            width: "calc(100% - 18px)",
                            minHeight: "100px",
                            marginLeft: "9px",
                            marginRight: "9px",
                            marginBottom: "4px",
                            marginTop: "4px",
                            position: "relative",
                            borderBottom: "1px solid gray"
                          }}
                          onClick={() => broadcast(
                            !!this.state.edit_layer_id ? "update_point_icon" : "point_icon",
                            {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: mapping_key}
                          )}
                        >
                          <div style={{marginLeft: "70px"}}><b>{status}</b></div>
                          <br/>
                          <div style={{marginLeft: "70px"}}><b>{value}</b></div>
                          <br/>
                          <div style={{marginTop: "10px"}} className="tool-input-label">{PRIKAZ10_HASH[key].desc}</div>
                          <img
                            src={`/transparent.png`}
                            style={{
                              position: "absolute",
                              top: "0px",
                              left: "0px",
                              width: `${PRIKAZ10_MAPPING[mapping_key].width}px`,
                              height: `${PRIKAZ10_MAPPING[mapping_key].height}px`,
                              background: `url(/${PRIKAZ10_HASH[key].group}.png) -${PRIKAZ10_MAPPING[mapping_key].x}px -${PRIKAZ10_MAPPING[mapping_key].y}px`,
                              transform: `scale(${64 / PRIKAZ10_MAPPING[mapping_key].width}) translate(${-transform}px, -${transform - 6}px)`
                            }}
                            alt=""
                          />
                      </div>)
                    })

                    return(arr)
                  })
                }
                </div>
              }

            </div>
          }
        </div>
      )
    } else {
      return(null)
    }
  }
}

export default PointTool;
